// Business accounts retain the owner's private name, but present their public
// organization name wherever the account itself is shown.
export const BUSINESS_ACCOUNT_ROLES = new Set([
  "transport_owner", "merchant", "agent", "organizer", "business_owner",
  "institution_manager", "iprint_shop", "food_vendor", "hostel_owner",
  "service_provider", "school_admin", "icompany", "delivery_provider",
]);

const BUSINESS_FALLBACKS = {
  transport_owner: "Transport company", merchant: "Business", agent: "Agency",
  organizer: "Event organizer", business_owner: "Business", institution_manager: "Institution",
  iprint_shop: "Print shop", food_vendor: "Food business", hostel_owner: "Hostel",
  service_provider: "Service provider", school_admin: "School", icompany: "Company",
  delivery_provider: "Delivery business",
};

export function accountDisplayName(user) {
  if (!user) return "";
  if (!BUSINESS_ACCOUNT_ROLES.has(user.role)) return user.name || "";
  return [user.business_name, user.shop_name, user.company_name, user.organization_name]
    .find((value) => typeof value === "string" && value.trim())?.trim()
    || BUSINESS_FALLBACKS[user.role]
    || "Business";
}
